/**
 * @typedef {Object} CustomerCreateDto
 * @property {string} customerName
 * @property {string} [customerType]
 * @property {string} [contactName]
 * @property {string} [contactEmail]
 * @property {string} [contactPhone]
 * @property {string} [billingAddress]
 * @property {string} [shippingAddress]
 * @property {string} [paymentTerms]
 * @property {string} [currency]
 * @property {string} [taxId]
 * @property {number} [creditLimit]
 * @property {string} [customerRating]
 * @property {string} [salesRep]
 * @property {boolean} [isDefault]
 */

/**
 * @typedef {Object} CustomerResponseDto
 * @property {number} customerId
 * @property {string} customerCode
 * @property {string} customerName
 * @property {boolean} isDefault
 * @property {boolean} isActive
 * @property {number} componentCount
 */

const BASE_PATH = 'v1/Customer';

export default function (instance) {
  return {
    getCustomers(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    getCustomerLookups() {
      return instance.get(`${BASE_PATH}/lookups`);
    },

    getCustomer(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    createCustomer(payload) {
      return instance.post(BASE_PATH, payload);
    },

    updateCustomer(id, payload) {
      return instance.put(`${BASE_PATH}/${id}`, payload);
    },

    deleteCustomer(id) {
      return instance.delete(`${BASE_PATH}/${id}`);
    },

    // Mapped components
    getCustomerComponents(customerId) {
      return instance.get(`${BASE_PATH}/${customerId}/components`);
    },

    createCustomerComponent(customerId, payload) {
      return instance.post(`${BASE_PATH}/${customerId}/components`, payload);
    },

    updateCustomerComponent(customerId, componentId, payload) {
      return instance.put(`${BASE_PATH}/${customerId}/components/${componentId}`, payload);
    },

    deleteCustomerComponent(customerId, componentId) {
      return instance.delete(`${BASE_PATH}/${customerId}/components/${componentId}`);
    },

    // Integration API token
    getApiTokenStatus(customerId) {
      return instance.get(`${BASE_PATH}/${customerId}/api-token`);
    },

    generateApiToken(customerId) {
      return instance.post(`${BASE_PATH}/${customerId}/api-token`);
    }
  };
}
